import Modal from 'react-bootstrap/Modal'
import { t } from '../locale'
import { FormControl, Row } from 'react-bootstrap'
import { ReactNode, useState } from 'react'
import v from '../validators'
import KButton from './KButton'
import { Form } from 'react-bootstrap'

interface KAccessProps {
  show: boolean
  pin?: string
  /** Defaults to true. When false, the pin input is hidden - the modal just confirms the action. */
  pinRequired?: boolean
  title?: string
  text?: string
  warningText?: string
  subtitle?: ReactNode
  confirmLabel?: string
  onConfirm?: (pin: number) => void
  onClose?: () => void
}

function KAccess(props: KAccessProps) {
  const pinRequired = props.pinRequired !== false
  const [pinCode, setPinCode] = useState(props.pin || '')
  const [isValidPin, setIsValidPin] = useState(true)

  function handlePin(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value
    setPinCode(value)
    setIsValidPin(v.pinCode(value))
  }

  function onClick() {
    if (typeof props.onConfirm === 'function') {
      props.onConfirm(Number(pinCode))
    }
  }

  function handleClose() {
    if (typeof props.onClose === 'function') {
      props.onClose()
    }
  }

  return (
    <Modal
      id='token'
      show={props.show}
      centered
      onHide={handleClose}
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header className='border-0 pb-0'>
        <h3 className='fw-bold text-dark mb-0'>{props.title ?? t('twoFactorAuth')}</h3>
      </Modal.Header>
      <Modal.Body className='pt-3'>
        {props.warningText && props.warningText !== '' ? (
          <p>{t(props.warningText)}</p>
        ) : (
          <p>{t('costWarning')}</p>
        )}
        {props.subtitle && (
          <div className='d-flex align-items-start gap-3 mb-3'>
            <i className='bi bi-file-earmark-text fs-3 text-primary' />

            <div>{props.subtitle}</div>
          </div>
        )}

        {pinRequired && (
          <div className='alert alert-success smaller d-flex align-items-center gap-2'>
            <i className='bi bi-check-circle-fill text-success' />
            <span>{t('pinCodeEmailSent')}</span>
          </div>
        )}
        {props.text && (
          <div className='alert alert-success d-flex align-items-center gap-2 mb-3'>
            <i className='bi bi-check-circle-fill text-success' />
            <span>{props.text}</span>
          </div>
        )}

        <Form
          className='needs-validation'
          noValidate
          onSubmit={e => {
            e.preventDefault()
            onClick()
          }}
        >
          {pinRequired && (
            <div className='mb-3'>
              <Form.Label className='fw-semibold'>{t('confirmationCode')}</Form.Label>
              <FormControl
                id='pinCode'
                isInvalid={!isValidPin}
                value={pinCode}
                onChange={handlePin}
                autoComplete='off'
                autoFocus
                required
                placeholder={t('enterCode')}
              />
            </div>
          )}
          <hr className='my-3' />
          <Row className='gx-2'>
            <div className='col-12 text-end'>
              <KButton
                variant='secondary'
                label={t('cancel')}
                className='text-white me-2'
                onClick={() => {
                  handleClose()
                }}
              />
              <KButton
                id='btn-confirm-proceed'
                type='submit'
                variant='primary'
                label={props.confirmLabel ?? t('confirm') + ' »'}
                className='text-white'
              />
            </div>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default KAccess
